import React, { Component } from 'react';
import WizardAccordion from 'Components/wizard-accordion/WizardAccordion.jsx';
import InputDescription from 'Components/InputDescription/InputDescription.jsx';
import MerchantInputDescription from 'Components/MerchantInputDescription/MerchantInputDescription.jsx';
import TableDynamicColumns from 'Components/table-dynamic-columns/TableDynamicColumns.jsx';
import './ReviewScreen.scss';
import PropTypes from 'prop-types';
import PageSelector from 'Components/PageSelector';
import { getQuestionnaireReviewData, getLiabilityData, getWriteOffReason, formatImageDataForReview, getCloseCaseData } from 'Utils/formatting';
import MerchantDocuments from '../MerchantDocuments/MerchantDocuments';
import counterpart from 'counterpart';

const __VISA__ = 'VISA';
const __CHARGEBACK__ = 'Chargeback';
class ReviewScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccordianIndex: -1,
      isOpen: false,
      children: '',
      idColumnKey: 'seq_key',
      showEditButton: false,
    };

    this.displayContent = this.displayContent.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  showModal = (editButtonId) => {
    this.props.buttonClick(editButtonId);
  }


  displayContent = (columnKey, index) => {
    switch (columnKey) {
      case 'Financial Adjustment':
        return (<TableDynamicColumns
          idColumnKey={this.state.idColumnKey}
          columns={this.props.getAdjustFinancialDataForReview().config}
          data={this.props.getAdjustFinancialDataForReview().data}
          extraClass="dynamic-table"
        />);
      case 'Questionnaire':
        const isNotMXPOrEMD = this.props.acquirerCode !== 'MXP' && this.props.acquirerCode !== 'EMD';
        return (this.props.cardBrand === __VISA__ && this.props.disputeStageName == __CHARGEBACK__ && this.props.actionViewCode == 'RTI' && isNotMXPOrEMD ?
          <div><InputDescription
            getReviewPageDescription={this.props.visaQnReviewData}
          /></div> : <div><InputDescription
            getReviewPageDescription={getQuestionnaireReviewData(this.props.issuerActionData, this.props.disputeStageName, this.props.jsonHeadings, this.props.reasonCodeCategoryDesc, this.props.representmentAmount)}
          /></div>
        );
      // case 'MerchantQuestionnaire': 
      //   return (<MerchantInputDescription
      //     getReviewPageDescription={getQuestionnaireReviewDataCE(this.props.compellingEvidenceInfo, this.props.selectedCountry, this.props.deliveryStatus)}
      //   />);
      case 'Accept Liability':
        return (<div><InputDescription
          getReviewPageDescription={getLiabilityData(this.props.issuerActionData, this.props.disputeStageName, this.props.jsonHeadings, this.props.reasonCodeCategoryDesc)}
          index={index}
          extraLabelStyle={this.props.extraLabelStyle}
        /></div>);
      case 'Write Off Reason':
        return (<div><InputDescription
          getReviewPageDescription={getWriteOffReason(this.props.issuerActionData)}
        /></div>);
      case 'Send Documents to Issuer':
      case 'Docs to Card Brand':
        return (<div> <PageSelector
          pageList={formatImageDataForReview(this.props.issuerSelectedPages)}
          imageCheckBoxRequired={false}
          updatePageSelectionIndex={this.props.updatePageSelectionIndexMethod}
          imageStyle
          selectAllButtonRequired={false}
        /></div>);
      case 'Merchant Message':
        return (<div><InputDescription
          isMerchantMessage = {true}
          getReviewPageDescription={this.props.merchantMessageTemp}
        /></div>);
      case 'Send Documents to Merchant':
        return (<div> <PageSelector
          pageList={formatImageDataForReview(this.props.merchantSelectedPages)}
          imageCheckBoxRequired={false}
          updatePageSelectionIndex={this.props.updatePageSelectionIndexMethod}
          imageStyle
          selectAllButtonRequired={false}
        /></div>);
      case 'Reason for Closing':
        return (<div><InputDescription
          getReviewPageDescription={getCloseCaseData(this.props.issuerActionData)}
        /></div>);
      case 'Merchant Docs':
        return (<MerchantDocuments merchantDocs={this.props.merchantDocs}/>)
      default:
        return <div />;
    }
  }
  setDescription(name) {
    let selectedIssuerData = this.props.issuerActionData[0];
    return selectedIssuerData && this.props.actionViewCode == 'PCF' && selectedIssuerData.selectedOption && selectedIssuerData.selectedOption[0] && selectedIssuerData.selectedOption[0].text.trim().toLowerCase() == "initiate pre-compliance" && name == "Send Documents to Card Brand" ? "Send Documents to Issuer" : name;
  }

  render() {
    const editButton = counterpart('globalTranslate.takeAction.edit');
    const { dataColumn } = this.props;
    const selectedReviewPageIndex = this.props.jsonHeadings.findIndex((reviewPage) => {
      return ((reviewPage.reviewScreenKey !== undefined && reviewPage.reviewScreenKey === dataColumn.columnKey));
    });

    return (<div>
      {
        this.props.showHeaderMessage && 
        <div className="review-desc"> 
          <div className={this.props.acquirerCode ==='HPY' ? 'review-desc-hpy--header' :'review-desc--header'}> {dataColumn.description} </div>
          <div className='review-desc--disclaimer'> {dataColumn.disclaimer} </div>
        </div>
      }
      {selectedReviewPageIndex !== -1 && <WizardAccordion
        headerText={this.props.displayHeaderIndex ? `${selectedReviewPageIndex + 1}. ${this.setDescription(dataColumn.name)}` : this.setDescription(dataColumn.name)}
        isOpen={this.props.isopen}
        toggleAccordion={() => this.props.toggleThisAccordion(dataColumn.columnKey)}
        id={dataColumn.columnKey}
        contentType={dataColumn.contentType}
        headerButtonName={editButton.toLowerCase().includes('missing') ? 'Edit' : editButton}
        headerButtonStyle="button-style-new"
        headerActionMethod={this.showModal}
        contentIndex={selectedReviewPageIndex}
        showEditButton={this.props.isopen}
      >{this.displayContent(dataColumn.description, selectedReviewPageIndex + 1)}</WizardAccordion>}
    </div>);
  }

}

ReviewScreen.propTypes = {
  buttonClick: PropTypes.func.isRequired,
  pageList: PropTypes.array,
  jsonHeadings: PropTypes.array,
  selectedAccordianIndex: PropTypes.number,
  toggleThisAccordion: PropTypes.func.isRequired,
  isopen: PropTypes.bool,
  getAdjustFinancialDataForReview: PropTypes.func,
  issuerActionData: PropTypes.object,
  issuerSelectedPages: PropTypes.array,
  merchantSelectedPages: PropTypes.array,
  compellingEvidenceInfo: PropTypes.object,
  merchantDocs: PropTypes.array,
  displayHeaderIndex: PropTypes.bool,
  showHeaderMessage: PropTypes.bool,
  acquirerCode: PropTypes.string
};

ReviewScreen.defaultProps = {
  buttonClick: () => { },
  pageList: [],
  jsonHeadings: [],
  selectedAccordianIndex: 0,
  toggleThisAccordion: () => { },
  isopen: false,
  getAdjustFinancialDataForReview: () => { },
  issuerActionData: {},
  issuerSelectedPages: [],
  merchantSelectedPages: [],
  compellingEvidenceInfo:{},
  merchantDocs: [],
  displayHeaderIndex: true,
  showHeaderMessage: false,
  acquirerCode: 'GPN'
};
export default ReviewScreen;
